export class AlarmEvent {
  ts!: Date | number;
  alarmStatusValue!: number;
  alarmStatus?: string;
  message!: string;
}
